// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateProductTag_createButton__1PDXi"};